const LazyLoading = () => {
  return <div></div>;
};

export default LazyLoading;
